
<div class="paginator flex center-v" [attr.disabled]="totalItemsCount===0">
  <button class="first" (click)="onButtonClicked('first')" [disabled]="currentPage===1">&laquo;</button>
  <button class="prev" (click)="onButtonClicked('prev')" [disabled]="currentPage===1">&lsaquo;</button><span>Page {{currentPage}} / {{totalPagesCount}}</span>
  <button class="next" (click)="onButtonClicked('next')" [disabled]="currentPage===totalPagesCount">&rsaquo;</button>
  <button class="last" (click)="onButtonClicked('last')" [disabled]="currentPage===totalPagesCount">&raquo;</button>
</div>
